import { useState, useEffect } from "react";
import Header from "./Header/Header";
import Sidebar from "./Sidebar/Sidebar";
import { IoSearch } from "react-icons/io5";
import Footer from "./Footer/Footer";
import { Link } from "react-router-dom";

import { Oval } from "react-loader-spinner";
import apiService from "../core/Service/detail";
import { postMethod } from "../core/service/common.api";
import Secondarymarketskeleton from "./Secondarymarketskeleton";

import urbon_blocksicon from "../assets/urbon_blocksicon.webp";
import skylinetowers_icon from "../assets/skylinetowers_icon.webp";
import valueinfi_icon from "../assets/valueinfi_icon.webp";
import maxigroup_icon from "../assets/maxigroup_icon.webp";
import maxigroup_img from "../assets/maxigroup_img.webp";
import skylinetowers_img from "../assets/skylinetowers_img.webp";
import valueinfi_img from "../assets/valueinfi_img.webp";
import urbon_blocksimg from "../assets/urbon_blocksimg.webp";


  const staticTokensByAssetType = [
    {
      assetType: "Real Estate",
      tokens: [
         {
          id: 1,
          cardTitle: "VGP Infi",
          cardSubTitle: "Private Villa Collection",
          description: "Exclusive luxury villas tokenized for fractional global ownership.",
          logoImg: urbon_blocksicon,
          cardImg: urbon_blocksimg,
          activeStatus: true,
          buttonText: "Sell",
          targetReturns: "10.00% p.a",
          assetClass: "Private Equity",
          fundTerm: "12.07 UB",
          minInvestment: "4,000",
          OwnedOwership: "Owned Owership",
          Ownedpercentage: "12.07%",
          details: [
            { label: "ROI", value: "12%" },
            { label: "Value", value: "$1.2M" },
            { label: "Duration", value: "2 Years" },
            { label: "Units", value: "500" },
          ],
        },
        // {
        //   id: 1,
        //   cardTitle: "Urbon Blocks",
        //   cardSubTitle: "Global Real Estate Fund",
        //   description: "High-end property investment opportunity.",
        //   logoImg: urbon_blocksicon,
        //   cardImg: urbon_blocksimg,
        //   activeStatus: true,
        //   buttonText: "Sell",
        //   targetReturns: "10.00% p.a",
        //   assetClass: "Private Equity",
        //   fundTerm: "12.07 UB",
        //   minInvestment: "4,000",
        //   OwnedOwership: "Owned Owership",
        //   Ownedpercentage: "12.07%",
        //   details: [
        //     { label: "ROI", value: "12%" },
        //     { label: "Value", value: "$1.2M" },
        //     { label: "Duration", value: "2 Years" },
        //     { label: "Units", value: "500" },
        //   ],
        // },
        // {
        //   id: 2,
        //   cardTitle: "Value Infi",
        //   cardSubTitle: "Private villa ",
        //   description: "A flagship tokenized real estate fund, transforming premium properties into accessible digital tokens.",
        //   logoImg: skylinetowers_icon,
        //   cardImg: skylinetowers_img,
        //    assetClass: "Private Equity",
        //    targetReturns: "10.00% p.a",
        //   activeStatus: true,
        //   minInvestment: "4,000",
        //    OwnedOwership: "Owned Owership",
        //    fundTerm: "12.07 UB",
        //   buttonText: "Sell",
        //    Ownedpercentage: "0.20%",
        //   details: [
        //     { label: "ROI", value: "9%" },
        //     { label: "Value", value: "$900K" },
        //     { label: "Duration", value: "3 Years" },
        //     { label: "Units", value: "300" },
        //   ],
        // },
        // {
        //   id: 3,
        //   cardTitle: "Maxi Group",
        //   cardSubTitle: "Commercial  Estate Fund",
        //   description: "A flagship tokenized real estate fund, transforming premium properties into accessible digital tokens.",
        //   logoImg: valueinfi_icon,
        //   cardImg: valueinfi_img,
        //   minInvestment: "4,000",
        //   targetReturns: "10.00% p.a",
        //    assetClass: "Private Equity",
        //    fundTerm: "12.07 UB",
        //   activeStatus: true,
        //    Ownedpercentage: "4.29%",
        //    OwnedOwership: "Owned Owership",
        //   buttonText: "Sell",
        //   details: [
        //     { label: "ROI", value: "9%" },
        //     { label: "Value", value: "$900K" },
        //     { label: "Duration", value: "3 Years" },
        //     { label: "Units", value: "300" },
        //   ],
        // },
        // {
        //   id: 4,
        //   cardTitle: "Skyline Towers",
        //   cardSubTitle: "Commercial Office Fund",
        //   description: "A flagship tokenized real estate fund, transforming premium properties into accessible digital tokens.",
        //   logoImg: maxigroup_icon,
        //    assetClass: "Private Equity",
        //    targetReturns: "10.00% p.a",
        //    fundTerm: "12.07 UB",
        //    minInvestment: "4,000",
        //   cardImg: maxigroup_img,
        //    Ownedpercentage: "10.98%",
        //   activeStatus: true,
        //    OwnedOwership: "Owned Owership",
        //   buttonText: "Sell",
        //   details: [
        //     { label: "ROI", value: "9%" },
        //     { label: "Value", value: "$900K" },
        //     { label: "Duration", value: "3 Years" },
        //     { label: "Units", value: "300" },
        //   ],
        // },
      ],
    },
    {
      assetType: "Art",
      tokens: [],
    },
  ];
  const staticTokensByAssetTypesecond = [
    {
      assetType: "Real Estate",
      tokens: [
        {
          id: 1,
          cardTitle: "VGP Infi",
          cardSubTitle: "Private Villa Collection",
          description: "Exclusive luxury villas tokenized for fractional global ownership.",
          logoImg: urbon_blocksicon,
          cardImg: urbon_blocksimg,
          activeStatus: true,
          buttonText: "Buy Now",
          OwnedOwership: "Owned Owership",
          Ownedpercentage: "12.07%",
          details: [
            { label: "Asset Class", value: "Real Estate Equity" },
            { label: "Seller", value: "Elena james" },
            { label: "Price", value: "$7,250" },
            { label: "Available Tokens", value: "200 tokens" },
          ],
        },
        {
          id: 2,
          cardTitle: "MetroBlocks",
          cardSubTitle: "Urban Residential Fund ",
          description: "Fractionalized access to multi-family apartments in fast-growing US cities.",
          logoImg: skylinetowers_icon,
          cardImg: skylinetowers_img,
          activeStatus: true,
           OwnedOwership: "Owned Owership",
          buttonText: "Buy Now",
           Ownedpercentage: "0.20%",
         details: [
            { label: "Asset Class", value: "Private Equity" },
            { label: "Seller", value: "John Doe" },
            { label: "Price", value: "$2,900" },
            { label: "Available Tokens", value: "50 tokens" },
          ],
        },
        {
          id: 3,
          cardTitle: " Harbor Heights",
          cardSubTitle: "Waterfront Properties Fund",
          description: "Tokenized luxury condos and villas near premium US waterfront locations.",
          logoImg: valueinfi_icon,
          cardImg: valueinfi_img,
          activeStatus: true,
           Ownedpercentage: "4.29%",
           OwnedOwership: "Owned Owership",
          buttonText: "Buy Now",
          details: [
            { label: "Asset Class", value: "Private Equity" },
            { label: "Seller", value: "Luther lane" },
            { label: "Price", value: "$9,000" },
            { label: "Available Tokens", value: "50 tokens" },
          ],
        },
        {
          id: 4,
          cardTitle: "Capital Square",
          cardSubTitle: "Mixed-Use Real Estate Fund",
          description: "Tokenized access to retail, office, and residential spaces in high-demand US cities.",
          logoImg: maxigroup_icon,
          cardImg: maxigroup_img,
           Ownedpercentage: "10.98%",
          activeStatus: true,
           OwnedOwership: "Owned Owership",
          buttonText: "Buy Now",
          details: [
            { label: "Asset Class", value: "Real Estate Equity" },
            { label: "Seller", value: "John Lark" },
            { label: "Price", value: "$4,890" },
            { label: "Available Tokens", value: "700 tokens" },
          ],
        },
      ],
    },
    {
      assetType: "Art",
      tokens: [],
    },
  ];

const SecondaryMarket = () => {
  const [sortFilter, setSortFilter] = useState("Price");
  const [searchTerm, setSearchTerm] = useState("");
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);


  useEffect(() => {
    setLoading(true)
    if(staticTokensByAssetType && staticTokensByAssetTypesecond){
setLoading(false)
    }
  }, [staticTokensByAssetType,staticTokensByAssetTypesecond]);

  const handleSortBy = (sortType) => {
    setSortFilter(sortType);

    // Sort tokens based on selection
    const sortedTokens = [...tokens].sort((a, b) => {
      switch (sortType) {
        case "APY %":
          return parseFloat(b.apy) - parseFloat(a.apy);
        case "Latest":
          return new Date(b.createdAt) - new Date(a.createdAt);
        case "Market Cap":
          return parseFloat(b.marketCap || 0) - parseFloat(a.marketCap || 0);
        case "Alphabetical":
          return a.fundName.localeCompare(b.fundName);
        default:
          return 0;
      }
    });

    setTokens(sortedTokens);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  

 

  return (
    <>
      <Header />

      <main className="main_flx">
        <Sidebar />

        {loading ? (
          <>
            <Secondarymarketskeleton />
          </>
        ) : (
          <div className="right_wrap market_wrap_main">
            <div className="market_tab_wrp secondmarket_tab_wrp">
             
<span className="secondmy_holdhead">
    Your holdings
</span>
              <div className="search_select_wrp">
                <div className="select_main">
                  <div className="dropdown">
                    <button
                      className="btn btn-secondary dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Sort by : <span>{sortFilter}</span>
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      {["Price", "Latest", "Market Cap", "Alphabetical"].map(
                        (option) => (
                          <li key={option}>
                            <a
                              className="dropdown-item"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleSortBy(option);
                              }}
                            >
                              {option}
                            </a>
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                </div>

                <div className="search_main">
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                  <IoSearch />
                </div>
              </div>
            </div>

            {error && (
              <div className="alert alert-warning" role="alert">
                {error}
              </div>
            )}

           <div className="market_tab_content secondmarket_tab_content">
      <div className="tab-content" id="pills-tabContent">
        {staticTokensByAssetType.map(({ assetType, tokens }) => (
          <div
            key={assetType}
            className={`tab-pane fade ${
              assetType === "Real Estate" ? "show active" : ""
            }`}
            id={`pills-${assetType.replace(/\s+/g, "-")}`}
            role="tabpanel"
            aria-labelledby={`pills-${assetType.replace(/\s+/g, "-")}-tab`}
          >
            {tokens.length === 0 ? (
              <div className="no-tokens-message">
                {/* <img src={noInvestImg} alt="No investments" className="no_inv_img" /> */}
                <p>No {assetType} tokens found</p>
              </div>
            ) : (
              <div className="dsh_inv_grid market_card_row">
                {tokens.map((displayToken) => (
                  <div key={displayToken.id} className="dsh_inv_card market_card">
                    <div className="dsh_inv_head">
                      <div className="dsh_inv_top mrkt_top_title">
                        <div className="mrkt_top_content">
                          <img
                            className="img_div"
                            src={displayToken.logoImg}
                            alt={displayToken.cardTitle}
                          />
                          <h6>{displayToken.cardTitle}</h6>
                        </div>
                        {displayToken.activeStatus && (
                          <span className="mrkt_sts">Owned</span>
                        )}
                      </div>
                      <img
                        src={displayToken.cardImg}
                        alt={displayToken.cardTitle}
                        className="card_img"
                      />
                      <div className="mrkt_main_cd_tlt">
                        <h3>{displayToken.cardTitle}</h3>
                        <h5>{displayToken.cardSubTitle}</h5>
                      </div>


                            <div  className="dsh_inv_cd_lft seconddsh_inv_cd_lft">
                              <h4>{displayToken.OwnedOwership}</h4>
                              <span>{displayToken.Ownedpercentage}</span>
                            </div>
                       
                    </div>

                    <button className="dsh_inv_btn">
                     <Link
  to={`/secondmarketdetails/${displayToken.id}`}
  state={{ data: displayToken }}
>
  {displayToken.buttonText}
</Link>

                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>

 <div className=" secondmarket_tab_wrp">
             
<span className="secondmy_holdhead">
    Buy Secondary Assets
</span>
              
            </div>


     <div className="market_tab_content secondmarket_tab_content">
      <div className="tab-content" id="pills-tabContent">
        {staticTokensByAssetTypesecond.map(({ assetType, tokens }) => (
          <div
            key={assetType}
            className={`tab-pane fade ${
              assetType === "Real Estate" ? "show active" : ""
            }`}
            id={`pills-${assetType.replace(/\s+/g, "-")}`}
            role="tabpanel"
            aria-labelledby={`pills-${assetType.replace(/\s+/g, "-")}-tab`}
          >
            {tokens.length === 0 ? (
              <div className="no-tokens-message">
                {/* <img src={noInvestImg} alt="No investments" className="no_inv_img" /> */}
                <p>No {assetType} tokens found</p>
              </div>
            ) : (
              <div className="dsh_inv_grid market_card_row">
                {tokens.map((displayToken) => (
                  <div key={displayToken.id} className="dsh_inv_card market_card">
                    <div className="dsh_inv_head">
                      <div className="dsh_inv_top mrkt_top_title">
                        <div className="mrkt_top_content">
                          <img
                            className="img_div"
                            src={displayToken.logoImg}
                            alt={displayToken.cardTitle}
                          />
                          <h6>{displayToken.cardTitle}</h6>
                        </div>
                        
                      </div>
                      <img
                        src={displayToken.cardImg}
                        alt={displayToken.cardTitle}
                        className="card_img"
                      />
                      <div className="mrkt_main_cd_tlt">
                        <h3>{displayToken.cardTitle}</h3>
                        <h5>{displayToken.cardSubTitle}</h5>
                        <p>{displayToken.description}</p>
                      </div>

                      <div className="dsh_inv_card_cnt">
                        <div className="dsh_inv_cd_flx">
                          {displayToken.details.slice(0, 2).map((d, i) => (
                            <div key={i} className="dsh_inv_cd_lft">
                              <span>{d.label}</span>
                              <h4>{d.value}</h4>
                            </div>
                          ))}
                        </div>
                        <div className="dsh_inv_cd_flx mt-4">
                          {displayToken.details.slice(2, 4).map((d, i) => (
                            <div key={i} className="dsh_inv_cd_lft">
                              <span>{d.label}</span>
                              <h4>{d.value}</h4>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <button className="dsh_inv_btn">
                      <Link
                        to={{
                          pathname: `/marketDetails/68e9112fa225b0fd406d62eb`,
                        }}
                       
                      >
                        {displayToken.buttonText}
                      </Link>
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
            <div className="mt-5">
              <Footer />
            </div>
          </div>
        )}
      </main>
    </>
  );
};

export default SecondaryMarket;
